<script setup lang="ts">
import Skeleton from '@/shared/ui/Skeleton/index';

const isMobile: boolean = useIsMobile();

const TEXT_LINES_COUNT = 8;
</script>

<template>
  <div :class="['journal-article-skeleton', { _mobile: isMobile }]">
    <div class="journal-article-skeleton__article">
      <div class="journal-article-skeleton__header">
        <Skeleton width="185px" height="14px" />
        <Skeleton width="60px" height="20px" />
      </div>
      <Skeleton width="80%" height="39px" />
      <Skeleton width="60%" height="21px" />
      <Skeleton width="100%" height="380px" />
      <div class="journal-article-skeleton__text">
        <Skeleton
          v-for="i in TEXT_LINES_COUNT"
          :key="i"
          :width="i % 3 ? '100%' : '70%'"
          height="16px"
        />
      </div>
    </div>
    <div v-if="!isMobile" class="journal-article-skeleton__sidebar">
      <Skeleton width="100%" height="320px" />
      <Skeleton width="100%" height="250px" />
    </div>
  </div>
</template>

<style lang="less">
.journal-article-skeleton {
  display: flex;
  justify-content: space-between;
  gap: @size-x10;

  &__article {
    .flex-column(@size-x5);

    width: 64.7%;
    max-width: 765px;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__text {
    .flex-column(@size-x3);
  }

  &__sidebar {
    .flex-column(@size-x5);

    width: 33.5%;
    max-width: 395px;
  }

  &._mobile &__article {
    width: 100%;
    max-width: 100%;
  }
}
</style>
